export default __webpack_public_path__ + "static/our-blog-bbf47aca63440d712a95307e525d5209.svg";